import { render } from "./api-clicks-list.vue?vue&type=template&id=dacf74fc"
import script from "./api-clicks-list.vue?vue&type=script&lang=js"
export * from "./api-clicks-list.vue?vue&type=script&lang=js"

import "./api-clicks-list.vue?vue&type=style&index=0&id=dacf74fc&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__